import MENU_ITEMS from '../components/sidebar/menuConfig'

// Build flat path → { module, page } map from menuConfig at module load time.
// Derived from menuConfig so it never goes stale when new routes are added.
const PATH_MAP = {}

MENU_ITEMS.forEach((item) => {
  if (item.type) return // skip section markers

  if (item.submenu) {
    item.submenu.forEach((sub) => {
      if (sub.type || !sub.url) return // skip dividers
      PATH_MAP[sub.url] = {module: item.name, page: sub.name}
    })
  }

  // top-level item without submenu (or as fallback for the parent url)
  if (item.url && !PATH_MAP[item.url]) {
    PATH_MAP[item.url] = {module: item.name, page: item.name}
  }
})

export function getModuleAndPage(pathname) {
  try {
    if (!pathname) return {module: 'unknown', page: 'unknown'}

    // 1. Exact match
    if (PATH_MAP[pathname]) return PATH_MAP[pathname]

    // 2. Strip one dynamic segment: /courier-config/master/123 → /courier-config/master
    const stripped = pathname.replace(/\/[^/]+$/, '')
    if (stripped && PATH_MAP[stripped]) return PATH_MAP[stripped]

    // 3. Prefix match for deeper nested paths
    const keys = Object.keys(PATH_MAP)
    const match = keys.find((key) => key !== '/' && pathname.startsWith(key + '/'))
    if (match) return PATH_MAP[match]

    // 4. Fallback: derive readable names from path segments
    const parts = pathname.split('/').filter(Boolean)
    const toTitle = (s) =>
      s.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
    return {
      module: parts[0] ? toTitle(parts[0]) : 'Unknown',
      page: parts.length > 1 ? parts.slice(1).map(toTitle).join(' / ') : toTitle(parts[0] || 'Unknown'),
    }
  } catch {
    return {module: 'unknown', page: 'unknown'}
  }
}
